<template>
  <div
    class="plv-iar-product__item pws-iar-product-list-item plv-iar-product__list-item-padding-x-16"
    :class="{
      'plv-iar-product__item--noCover': !good.cover,
      'plv-iar-product__item--small': useSmall,
      'plv-iar-product__item--prosition': good.productType === 'position',
      'plv-iar-product__item--top': isTop,
      'plv-iar-product__item--external-link': redirectDirectlyEnabled
    }"
    :data-rank="good.rank"
    :data-number="number"
    @click="clickProduct"
  >
    <icon-topping class="plv-iar-product__item-top-icon" v-if="isTop && !isMobile"/>
    <div class="plv-iar-product__item__inner">
      <!-- 商品图片 -->
      <div
        v-if="good.cover"
        class="plv-iar-product__item__cover pws-iar-product-list-cover"
      >
        <img :src="ossCompress(good.cover, { width: 300 })" :alt="good.name" />
        <span v-if="!hideNumber" class="plv-iar-product__item__cover__number pws-iar-product-list-cover-number plv-font-din-pro-regular">{{ number }}</span>

        <div v-if="isSoldOut" class="plv-iar-product__item__cover__sold-out">- {{ iarTrans('product.soldOut') }} -</div>

        <product-explain v-if="isMobile && productExplainEnabled" :explain-status="good.explainStatus" :cover="good.cover" @click-explain="clickExplain" />
      </div>

      <div class="plv-iar-product__item__info">
        <div class="plv-iar-product__item__info__top">
          <!-- 商品名称 -->
          <div
            :title="good.name"
            class="plv-iar-product__item__name"
            :class="{
              'plv-iar-product__item__name--position': good.productType === 'position'
            }"
          >
            <!-- 序号 -->
            <span
              v-if="!good.cover && !hideNumber"
              class="plv-iar-product__item__name__number pws-iar-product-list-number plv-font-din-pro-regular"
            >{{ number }}</span>
            <product-explain v-if="isMobile && productExplainEnabled && !good.cover && good.explainStatus !== 'explained'" :explain-status="good.explainStatus" :cover="good.cover" @click-explain="clickExplain" />
            <!-- 名称 -->
            <span
              class="plv-iar-product__item__name__text pws-product-theme-text-color pws-iar-product-list-name"
              :class="{
                'plv-iar-text-singleline': hasTitleLabelAndDesc,
                'plv-iar-text-multiline': !hasTitleLabelAndDesc
              }"
            >{{ good.name }}</span>
          </div>

          <!-- 商品标签 -->
          <div
            v-if="labels.length"
            class="plv-iar-product__item__labels"
          >
            <product-label
              v-for="(label, index) in labels"
              :key="index"
              class="plv-iar-product__item__labels__item pws-iar-product-list-label"
              :class="{
                'plv-iar-product__item__labels__item--job': good.productType === 'position'
              }"
              :enable-watch-skin="isJobType"
              :max-width="Math.min(label.length * 12.3, 80)"
              :text="label"
            />
          </div>
        </div>

        <!-- 商品描述 -->
        <div
          v-if="good.productDesc && good.productType !== 'position'"
          class="plv-iar-product__item__desc pws-iar-product-list-desc"
          :class="{
            'plv-iar-product__item__desc--pr': labels.length
          }"
          :title="good.productDesc"
        >
          <span>{{ good.productDesc }}</span>
        </div>

        <!-- 价格+购买按钮 -->
        <div class="plv-iar-product__item__bottom">
          <!-- 普通商品价格 -->
          <template v-if="good.productType === 'normal'">
            <template v-if="shouldHidePrice">
              <div class="plv-iar-product__item-flex">
                <div class="plv-iar-product__item__price plv-font-din-pro-regular">
                  <span class="plv-iar-product__item__price-symbol">¥</span>
                  <span class="plv-iar-product__item__price-value plv-font-din-pro-regular">{{ hidePriceQuestionMarks }}</span>
                </div>
                <span class="plv-iar-product__item__price-tag plv-font-din-pro-regular">{{ iarTrans('product.hidePrice') }}</span>
                <div class="plv-iar-product__item__hide-price plv-iar-product__item__old-price pws-body-font-color3" :title="oldPrice(good)">{{ oldPrice(good) }}</div>
              </div>
            </template>
            <template v-else-if="good.priceType === 'CUSTOM'">
              <div class="plv-iar-product__item-flex">
                <div class="plv-iar-product__item__price" :style="{ maxWidth: customPriceBoxWidth }">
                  <span :title="good.customPrice">{{ good.customPrice }}</span>
                </div>
                <div class="plv-iar-product__item__old-price pws-body-font-color3" :title="oldPrice(good)">{{ oldPrice(good) }}</div>
              </div>
            </template>
            <template v-else>
              <div class="plv-iar-product__item-flex">
                <div
                  class="plv-iar-product__item__price plv-font-din-pro-regular"
                  :class="{
                    'plv-iar-product__item__price--free': good.realPrice === 0
                  }"
                >
                  <span :title="realPrice(good.realPrice)">{{ realPrice(good.realPrice) }}</span>
                </div>
                <div class="plv-iar-product__item__old-price pws-body-font-color3" :title="oldPrice(good)">{{ oldPrice(good) }}</div>
              </div>
            </template>
          </template>

          <!-- 金融商品价格 -->
          <template v-if="good.productType === 'finance'">
            <div class="plv-iar-product__item__price">
              <span>{{ good.yield }}</span>
            </div>
          </template>

          <template v-if="good.productType === 'position'">
            <div class="plv-iar-product__item__price">
              <span>{{ treatment }}</span>
            </div>
          </template>

          <!-- 购买按钮 -->
          <div
            class="plv-iar-product__item__btn pws-iar-product__item__btn"
            :class="{
              'plv-iar-product__item__job': good.productType === 'position'
            }"
          >
            <template v-if="good.productType === 'position'">
              <div
                class="plv-iar-product__item__job__detail"
                @click.stop="$emit('job-detail', good)"
              >
                <div>{{ iarTrans('product.jobDetail') }}</div>
              </div>
            </template>

            <product-explain v-if="isMobile && productExplainEnabled && !good.cover && good.explainStatus === 'explained'" :explain-status="good.explainStatus" :cover="good.cover" @click-explain="clickExplain" />

            <buy-button
              :good="good"
            >
              <template #default="{ buttonText, disabled }">
                <div
                  class="plv-iar-product__item__btn__content pws-iar-product-list-button"
                  :class="{
                    'plv-iar-product__item__btn__content--disabled': disabled
                  }"
                >
                  {{ buttonText }}
                </div>
              </template>
            </buy-button>
          </div>
        </div>
      </div>
    </div>

    <buy-button
      v-if="redirectDirectlyEnabled"
      :good="good"
      :is-cover-all="true"
    />
  </div>
</template>

<script>
import goodMixin from '../good-mixin';
import ProductLabel from '../ProductLabel';
import BuyButton from '../BuyButton/BuyButton.vue';
import ProductExplain from './ProductExplain';
import { IconTopping } from '@/icon-components/map';
// import basicMixin from '../../../assets/mixins/basic';

export default {
  components: {
    ProductLabel,
    BuyButton,
    ProductExplain,
    IconTopping
  },

  mixins: [goodMixin],

  props: {
    contentWidth: {
      type: Number,
    },
    hideNumber: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    useSmall() {
      return this.contentWidth <= 270;
    },
    customPriceBoxWidth({ contentWidth }) {
      if (contentWidth <= 360) {
        return '90px';
      }
      if (contentWidth <= 400) {
        return '120px';
      }
      return '100%';
    },
    hasTitleLabelAndDesc() {
      return this.good.name && this.labels.length && (this.good.productDesc && this.good.productType !== 'position');
    },
  },
};
</script>

<style lang="scss">
@import '../../../assets/styles/basic.scss';

.plv-iar-product__item {
  //padding-bottom: 14px;
  //margin-bottom: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, .1);
  color: #fff;
}

.plv-iar-product__item--external-link {
  position: relative;
}

.plv-iar-product__item__inner {
  display: flex;
}

.plv-iar-product__item__cover {
  width: 103px;
  height: 103px;
  overflow: hidden;
  border-radius: 4px;
  position: relative;
  transform: translate3d(0, 0, 0);
  margin-right: 8px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.plv-iar-product__item__cover__sold-out {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .5);
  color: #fff;
  font-size: 12px;
  top: 0;
  left: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.plv-iar-product__item-flex {
  display: flex;
  align-items: center;
  width: 100%;
}

.plv-iar-product__item__info {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 90px;
}

.plv-iar-product__item__cover__number {
  position: absolute;
  top: 0;
  left: 0;
  width: 27px;
  height: 16px;
  line-height: 16px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background: rgba(0, 0, 0, .35);
  border-radius: 0 0 4px 0;
}

.plv-iar-product__item__name {
  font-size: 12px;
  line-height: 17px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  word-break: break-all;
}

.plv-iar-product__item__name__number {
  display: inline-block;
  font-size: 12px;
  height: 16px;
  line-height: 16px;
  min-width: 27px;
  text-align: center;
  padding: 0 3px;
  border-radius: 4px;
  background: rgba(#fff, .35);
  margin-right: 2px;
  box-sizing: border-box;
  flex-shrink: 0;
  white-space: nowrap;
}

.plv-iar-product__item__name__desc {
  color: rgba(#fff, 0.8);
  font-size: 12px;
  display: flex;
  align-items: center;
  margin-left: 4px;
  cursor: pointer;
}

.plv-iar-text-singleline {
  @include text-singleline;
}

.plv-iar-text-multiline {
  @include text-multiline;
}

.plv-iar-product__item__name__desc__icon {
  width: 10px;
  height: 20px;
  margin-left: 2px;
  background-image: url(./imgs/right.png);
  background-size: 20px 20px;
  background-position-x: -3px;
}

.plv-iar-product__item__labels {
  display: flex;
  align-items: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 4px;
}

.plv-iar-product__item__labels__item {
  background: rgba(255, 255, 255, .1);
  border-radius: 4px;
  color: #fff;
  margin-right: 8px;
  flex: 1;
  max-width: 80px;
  min-width: auto;
  padding: 0 4px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;

  &:last-child {
    margin-right: 0;
  }
}

.plv-iar-product__item__desc {
  font-size: 12px;
  color: #fff;
  opacity: .7;
  @include text-singleline;
}

.plv-iar-product__item__price-symbol {
  font-size: 12px;
  color: #FF5252;
}

.plv-iar-product__item__price-value {
  font-size: 18px;
  color: #FF5252;
}

.plv-iar-product__item__price-tag {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
  display: inline-block;
  margin: 6px 2px 0 3px;
}

.plv-iar-product__item__hide-price {
  margin-top: 5px;
}

.plv-iar-product__item__desc--pr {
  margin-bottom: 4px;
}

.plv-iar-product__item--prosition {
  .plv-iar-product__item__bottom {
    flex-direction: column;
  }
  .plv-iar-product__item__price {
    width: 100%;
  }
}

.plv-iar-product__item__bottom {
  margin-top: auto;
  width: 100%;
  display: flex;
  align-items: flex-end;
  min-height: 24px;

  .plv-iar-product__item-flex {
    flex-wrap: wrap;
    gap: 2px 4px;
  }

  .plv-iar-product__item__btn__content {
    min-width: 64px;
    display: block;
    color: #fff;
    background: #FF6666;
    text-decoration: none;
    outline: none;
    position: relative;
    padding: 0 8px;
    box-sizing: border-box;
    text-align: center;
    height: 24px;
    line-height: 24px;
    border-radius: 456px;
    font-size: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

.plv-iar-product__item__price {
  color: #FF6666;
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
}

.plv-iar-product__item__old-price {
  color: #B2B2B2;
  font-size: 12px;
  line-height: 16px;
  text-decoration: line-through;
}

.plv-iar-product__item__btn {
  margin-left: auto;
}

.plv-iar-product__buy-button--disabled {
  .plv-iar-product__item__btn__content {
    background: #CDCDCD;
  }
}

.plv-iar-product, .plv-iar-mobile-product {

  .plv-iar-product__buy-button {
    overflow: hidden;
    max-width: 96px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .plv-iar-product__item__btn {
    display: flex;
    margin-left: 0;
    justify-content: flex-end;
  }
  .plv-iar-product__item--small {
    .plv-iar-product__item__bottom {
      flex-direction: column;
      align-items: flex-start;
    }
    .plv-iar-product__item__btn {
      width: 100%;
      margin-top: 4px;
      justify-content: flex-start;
    }
  }

  .plv-iar-product__item__bottom {
    justify-content: space-between;
  }

  .plv-iar-product__label__content {
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
  }

  .plv-iar-product__item__price {
    font-size: 14px;
    text-align: left;
  }

  .plv-iar-product__item__cover {
    height: 103px;
    width: 103px;
    border-radius: 8px;
    border: 1px solid rgba(51, 51, 51, 0.08);
  }

  .plv-iar-product__item__name__text {
    font-size: 12px;
    line-height: 17px;
  }

  .plv-iar-product__item__job__detail {
    flex: 1;
    max-width: 64px;
    width: 64px;
    height: 24px;
    box-sizing: border-box;
    line-height: 23px;
    padding: 0 4px;
    margin-right: 5px;
    background: transparent;
    border: 1px solid #F15D5D;
    cursor: pointer;
    border-radius: 456px;
    color: #F15D5D;
    font-size: 12px;
    text-align: center;

    div {
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .plv-iar-product__item__btn__content {
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 456px;
    font-size: 12px;
    white-space: nowrap;
    min-width: auto;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .plv-iar-product__item__btn__content--disabled {
    opacity: 0.6;
  }
}

.plv-iar-mobile-product {
  .plv-iar-product__item__job__detail {
    border-color: rgba(0, 0, 0, 0.2);
    color: rgba(0, 0, 0, 0.6);
    font-weight: 500;
  }
}

.plv-iar-product__item__job {
  display: flex;
  width: 100%;
}

.plv-iar-product__item__labels__item {
  flex: 1;
  max-width: 80px;
  min-width: auto;
  padding: 0;
  color: #fff;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  background: rgba(255, 255, 255, .1);
}

.plv-iar-product__item--small:not(.plv-iar-product__item--noCover) {
  .plv-iar-product__item__cover {
    position: absolute;
    width: 56px;
    height: 56px;
  }
  .plv-iar-product__item__info__top {
    min-height: 56px;
    padding-left: 62px;
    margin-bottom: 4px;
  }
}

@media screen and (max-width: 280px) {
  .plv-iar-product .plv-iar-product__item--job .plv-iar-product__item__cover {
    width: 75px;
    height: 75px;
  }
}
.plv-iar-product__list-item-padding-x-16 {
  padding: 12px 16px;
}
.plv-iar-product__item--top {
  background: rgba(241, 93, 93, 0.08) !important;
  position: relative;
  .plv-iar-product__item-top-icon {
    position: absolute;
    top: 8px;
    right: 8px;
    color: #F15D5D;
  }
}
</style>
